import {
	multiPolygon,
	polygon,
	buffer,
	union,
	bbox,
	bboxPolygon,
} from '@turf/turf'

import { tableWithSameValue, allItemsInLookup } from '../utils'

import {STATE_MASK_ID} from "../constants";


const TURF_OBJ = {
	MultiPolygon: multiPolygon,
	Polygon: polygon
}


export default class TurfManager {
	constructor(map, cartoLayers) {
		this._map = map
	}

	getBoundForStates = (states) => {
		if (!this._map || !this._map.getStyle())
			return null

		const layerIds = tableWithSameValue(this._map.getStyle().layers.map(layer => layer.id), true)
		const stateMaskLayerExistsOnMap = allItemsInLookup([STATE_MASK_ID], layerIds)
		
		if (stateMaskLayerExistsOnMap) {
			const features = this._map.querySourceFeatures(STATE_MASK_ID, {sourceLayer: STATE_MASK_ID})
			const bb = geosToBboxPolygons(getGeosAnyValues(features, 'name', states))
			if (bb.length > 0) {
				const uBB = union(...bb)
				const bounds = bbox(uBB)
				return [[bounds[0], bounds[1]], [bounds[2], bounds[3]]]
			}
		}
		return null
	}
}

const getGeosAnyValues = (allFeatures, fieldName, anyValues) => {
	var geos = allFeatures
	geos = geos.filter(f => {
		var isAnyValue = false
		anyValues.forEach(value => {
			if (f.properties[fieldName] === value)
				isAnyValue = true
		})
		return isAnyValue
	})

	geos = geos.map(f => {
		const g = f.geometry
		const res = buffer(TURF_OBJ[g.type](g.coordinates), 0)
		return res
	})
	return geos
}

const geosToBboxPolygons = (geos) => {
	return geos.map(g => bboxPolygon(bbox(g)))
}
